"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const redux_saga_1 = __importDefault(require("redux-saga"));
const client_config_1 = __importDefault(require("src/utils/client-config"));
const error_1 = __importDefault(require("src/redux/middleware/error"));
const errors_1 = require("src/utils/errors");
const ls_client_1 = __importDefault(require("src/utils/ls-client"));
const survey_1 = require("src/utils/survey");
const reducers_1 = require("../reducers");
const actions_1 = require("../actions");
// сохраняем location в стор, чтобы было проще тестировать верстку
// eslint-disable-next-line max-statements, complexity
function configureStore({ location, rootSaga, surveyConfig, rootService }) {
    const { host, pathname, search } = location;
    const config = (0, client_config_1.default)({ host, pathname, search, isHaveUxQuestions: false });
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_1.compose;
    const sagaMiddleware = (0, redux_saga_1.default)({
        onError: errors_1.sendError,
        context: { rootService }
    });
    const lsIsEnabled = config.localStorage.enable;
    const lsVersion = config.localStorage.version;
    const lsClient = lsIsEnabled && ls_client_1.default.canUse() ? new ls_client_1.default(`pythia${lsVersion}`) : null;
    const slug = (0, survey_1.getSlugFromPathname)({ pathname });
    const defaultStoreState = (0, reducers_1.getDefaultStoreState)({ host, pathname, search });
    const stateFromSurveyConfig = (0, survey_1.getSurveyStateFromConfig)({ slug, surveyConfig, location });
    let stateFromLS;
    if (lsClient) {
        // @ts-expect-error TS(2345): Argument of type '{ pathname: any; search: any; }'... Remove this comment to see the full error message
        stateFromLS = (0, survey_1.getSurveyStateFromLS)(lsClient, { pathname, search });
        if (stateFromLS === null || stateFromLS === void 0 ? void 0 : stateFromLS.questions) {
            Object.values(stateFromLS.questions).forEach(question => {
                question.errorVisible = false;
            });
        }
        if (stateFromLS === null || stateFromLS === void 0 ? void 0 : stateFromLS.notifications) {
            stateFromLS.notifications = null;
        }
    }
    const preloadedState = stateFromSurveyConfig || stateFromLS;
    if (preloadedState) {
        // проставляем актуальный location, чтобы подхватывались гет-параметры
        preloadedState.location = { host, pathname, search };
    }
    const initState = preloadedState || defaultStoreState;
    const store = (0, redux_1.createStore)(reducers_1.reducer, initState, composeEnhancers((0, redux_1.applyMiddleware)(...[error_1.default, sagaMiddleware].filter(Boolean))));
    // @ts-ignore
    if (module.hot) {
        // @ts-ignore
        module.hot.accept('./../reducers', () => {
            store.replaceReducer(reducers_1.reducer);
        });
    }
    // Для cypress тестов
    if (window.Cypress) {
        window.store = store;
    }
    sagaMiddleware.run(rootSaga, { store, lsClient });
    const isStateValid = initState.pages.list.length > 0;
    if (preloadedState && isStateValid) {
        store.dispatch((0, actions_1.restoreSurveyFromPreloadedState)());
    }
    else {
        const queryString = search.substring(1);
        store.dispatch((0, actions_1.getSurveyRequest)(slug, queryString));
    }
    return store;
}
exports.default = configureStore;
